import axios from 'axios';

const createApi = () => {
  return axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

class ApiFactoryClass {
  constructor() {
    this._api = createApi();
  }

  getApi() {
    return this._api;
  }
}

const ApiFactory = new ApiFactoryClass();
Object.freeze(ApiFactory);

export default ApiFactory;